import TextField, { TextFieldProps } from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import { ChangeEvent, FocusEvent, ReactNode } from "react";

export type FormFieldProps = Omit<TextFieldProps, "error" | "helperText"> & {
  error?: boolean;
  helperText?: ReactNode;
  /** When true and value is empty, render nothing (legacy TextControl behavior). */
  hideEmpty?: boolean;
  /** Optional Bootstrap-style wrapper class; omit for layout-free usage. */
  wrapperClassName?: string;
};

export function FormField({
  error,
  helperText,
  hideEmpty,
  wrapperClassName,
  value,
  onBlur,
  onChange,
  ...rest
}: FormFieldProps) {
  if (hideEmpty && (value === undefined || value === null || value === "")) {
    return null;
  }

  const field = (
    <>
      <TextField
        variant="outlined"
        fullWidth
        error={!!error}
        className={error ? "error" : undefined}
        value={value ?? ""}
        onBlur={onBlur as (e: FocusEvent<HTMLInputElement>) => void}
        onChange={onChange as (e: ChangeEvent<HTMLInputElement>) => void}
        helperText={error ? undefined : helperText || undefined}
        {...rest}
      />
      {!!error && helperText != null && helperText !== "" && (
        <FormHelperText className="error-message" error>
          {helperText}
        </FormHelperText>
      )}
      {!!error && helperText === undefined && (
        <FormHelperText className="error-message" error>
          Required
        </FormHelperText>
      )}
    </>
  );

  if (wrapperClassName) {
    return <div className={wrapperClassName}>{field}</div>;
  }

  return field;
}

export default FormField;
